import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoginService } from '@delhivery/auth';
import { AUTH_CONFIG } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(
    private loginService: LoginService,
    private translate: TranslateService
  ) {
    translate.setDefaultLang('en');
    // Always activate a language so translated labels/placeholders render even
    // if the later IP-based language lookup fails or is slow.
    translate.use(localStorage.getItem('language') || 'en');
  }

  async ngOnInit() {
    this.removeAutoInjectedHeader();
    await this.checkAuthenticationStatus();
  }

  /**
   * AuthModule always injects its own <lib-auth-header> as a direct child of <body>. That copy
   * is OnPush and outside our component tree, so it never re-renders when LayoutComponent sets
   * the header config. LayoutComponent renders its own <lib-auth-header> instead, so drop this one.
   */
  private removeAutoInjectedHeader() {
    document.querySelector('body > lib-auth-header')?.remove();
  }

  private async checkAuthenticationStatus() {
    const inCallback = window.location.pathname.includes('/lib-auth-oauth-callback');
    const hasValidToken = !!sessionStorage.getItem('access_token');
    if (!hasValidToken && !inCallback) {
      await this.redirectToKeycloakLogin();
    }
  }

  private async redirectToKeycloakLogin() {
    const redirectUri = `${window.location.protocol}//${window.location.host}/lib-auth-oauth-callback`;
    try {
      await this.loginService.login(AUTH_CONFIG.issuer, AUTH_CONFIG.clientId, redirectUri);
    } catch (error) {
      console.error('Authentication error:', error);
    }
  }
}
